import React from "react"
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import { useHistory, useLocation } from "react-router-dom";
import '../Dashboard/Dashboard.css';

const Dashboard = () => {
  const history = useHistory();
  return (
    <div>
      <main id="main p-0" class="">

        <section id="hero" class="d-flex align-items-center">
          <div class="container">
            <div class="row hero-banner">
              <div class="col-lg-8">
                <div class="bannertext-bg">
                  <h1>Welcome to Auction 24/7</h1>
                  <h2>Where you can sell Dealer trade-in with the <br></br>right money</h2>
                </div>
                <div class="get-start">
                  {localStorage.getItem("islogedIn") === "true" ? "" :
                    <a onClick={() => history.push('/registration')} class="btn-get-started"> Become a Seller </a>}

                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="playstoreBlock" className="playstoreBlock">
          <div className="container">
            <div className="row content">
              <div className="col-lg-12">
                <img src={appstore} />
                <img src={googleplay} />
              </div>
            </div>
          </div>
        </section>
      </main>

    </div>
  )
}

export default Dashboard